package com.essntl.features.currency.data.supabase

import com.essntl.features.currency.domain.model.CurrencyModel
import kotlinx.serialization.Serializable

@Serializable
data class CurrencyDto(
    val symbol: String,
    val code: String,
    val name: String,
) {
    fun toModel() =
        CurrencyModel(
            symbol = symbol,
            code = code,
            name = name,
        )
}
